import { getMyOrganization, Organization } from "@src/redux/index";
import { Col, Form, FormInstance, Input, Row, Select } from "antd";
import { startCase } from "lodash";
import React from "react";
import { useSelector } from "react-redux";

interface Props {
  form: FormInstance;
  options: any;
  handleChange: any;
  index: any;
  label?: string;
  isRequired: boolean;
  allowClear: boolean;
  className?: string;
  levelAttributes?: any;
  showLevelAttribute?: boolean;
  handleChangeLevelAttributes: any;
  myOrganizationResult?: Organization | null;
  showAllLabel?: boolean;
  onClear?: (index: number) => void;
}

const DynamicSelect: React.FC<Props> = (props) => {
  const {
    options,
    handleChange,
    index,
    label,
    isRequired,
    allowClear,
    className,
    levelAttributes,
    showLevelAttribute = false,
    handleChangeLevelAttributes,
    showAllLabel = true,
    onClear
  } = props;

  const handleSelectChange = (value: string, option: any) => {
    // Find the full organization object from options
    const selectedOrganization = options?.find((org: any) => org.id === value);

    // Call handleChange with the correct parameters
    handleChange(value, label, selectedOrganization || option, index);
  };

  return (
    <div key={index}>
      {showLevelAttribute &&
      <Row gutter={10} className="level-attribute-list-container">
          {levelAttributes?.[label || ""] &&
        levelAttributes?.[label || ""]?.length > 0 ?
        (levelAttributes?.[label || ""]).map(
          (list, levelAttributeIndex) => {
            let attributeOptions =
            list?.optionList && list?.optionList?.length > 0 ?
            list?.optionList?.map((option) => {
              return {
                label: startCase(option),
                value: option
              };
            }) :
            [];
            return (
              <Col
                span={
                levelAttributes?.[label || ""]?.length > 1 ? 12 : 24}

                key={levelAttributeIndex}>
                
                      <Form.Item
                  name={[
                  "levelAttributeId",
                  levelAttributeIndex,
                  "id"]}

                  label={list?.name}
                  className={className}
                  hidden
                  initialValue={list?.id}>
                </Form.Item>
                      <Form.Item
                  name={[
                  "levelAttributeId",
                  levelAttributeIndex,
                  "value"]}

                  label={list?.name}
                  className={className}>
                  
                        <Select
                    options={attributeOptions}
                    onChange={(value: string) =>
                    handleChangeLevelAttributes(
                      value,
                      label,
                      attributeOptions?.[0],
                      index
                    )} />

                  
                      </Form.Item>
                    </Col>);

          }
        ) :
        ""}
        </Row>}
      
      <Form.Item
        name={["organizationId", index]}
        label={label}
        rules={[{ required: isRequired, message: `${label} is required` }]}
        className={className}>
        
        <Select
          options={
          // options && options?.length > 0 && show_all_label
          //   ? [{ id: "", name: "All" }].concat(options)
          //   :
          options}

          onChange={handleSelectChange}
          fieldNames={{ label: "name", value: "id" }}
          allowClear={allowClear}
          placeholder={
          showAllLabel ? <div style={{ color: "black" }}>All</div> : ""}

          onClear={() => onClear?.(index)} />
        
      </Form.Item>
    </div>);

};

export default DynamicSelect;